import { render, staticRenderFns } from "./MoonPrediction.vue?vue&type=template&id=434ea5be&scoped=true&"
import script from "./MoonPrediction.vue?vue&type=script&lang=js&"
export * from "./MoonPrediction.vue?vue&type=script&lang=js&"
import style0 from "./MoonPrediction.vue?vue&type=style&index=0&id=434ea5be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434ea5be",
  null
  
)

export default component.exports